import React, { Component, Fragment } from 'react';
import Datas from '../../data/course/item.json'

import { Col } from 'react-bootstrap';


class CourseItemList extends Component {
    render() {
        return (
            <Fragment>
                {/* Course Item */}
                {
                    Datas.map((data, i) => (
                        <Col md="12" key={i}>
                            <div className="course-item d-flex">
                                <div className="course-image-box">
                                    <div className="course-image" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/images/${data.imgUrl})` }}>
                                    
                                       
                                    </div>
                                </div>
                                <div className="course-content">
                                    <h6 className="heading">{data.courseTitle}</h6>
                                    <div className="rating">
                                        <ul className="list-unstyled list-inline">
                                          
                                            <li className="list-inline-item fw-bold">{data.price}</li>
                                        </ul>
                                    </div>
                                    <p className="desc">{data.courseDesc}</p>
                                   
                                </div>
                            </div>
                        </Col>
                    ))
                }
                
            

            </Fragment>
        )
    }
}

export default CourseItemList
